import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecordRounded';

export const LT10 = 'lt10';
export const BT1020 = 'bt1020';
export const BT2030 = 'bt2030';
export const EXPIRED = 'expired';
export const EMPLOYEE_DRIVER = 'driver';
export const EMPLOYEE_VEHICLE = 'vehicle';

import { dangerSvg, cautionSvg, warningSvg, successSvg } from './styles.css';

class ListingFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employeeTypes: props.employeeTypes || [],
      vehicleTypesSelected: []
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.employeeTypes) !== JSON.stringify(this.props.employeeTypes)) {
      this.setState({ employeeTypes: this.props.employeeTypes });
    }
  }

  handleEmployeeTypeChange = (typeId) => {
    const { employeeTypes } = this.state;
    const typeExists = employeeTypes.includes(typeId);
    
    if (typeExists) {
      this.setState({
        employeeTypes: employeeTypes.filter(type => type !== typeId)
      });
    } else {
      this.setState({
        employeeTypes: [...employeeTypes, typeId]
      });
    }
  };

  handleVehicleTypeChange = (typeId) => {
    const { vehicleTypesSelected } = this.state;
    
    const typeExists = vehicleTypesSelected.includes(typeId);
    
    if (typeExists) {
      this.setState({
        vehicleTypesSelected: vehicleTypesSelected.filter(type => type !== typeId)
      });
    } else {
      this.setState({
        vehicleTypesSelected: [...vehicleTypesSelected, typeId]
      });
    }
  };

  handleSituationChange = (event) => {
    const { onToggleSituation } = this.props;
    
    if (onToggleSituation) {
      onToggleSituation(event);
    }
  };

  handleUnboundChange = (event) => {
    const { checked } = event.target;
    const { onToggleUnbound } = this.props;
    
    if (onToggleUnbound) {
      onToggleUnbound(checked);
    }
  };

  handleApply = () => {
    const { onApply } = this.props;
    const { situation, unbound } = this.props;
    const { employeeTypes, vehicleTypesSelected } = this.state;
    const { originType } = this.props;
    
    if (onApply) {
      onApply({
        situation,
        unbound,
        employeeTypes: originType === EMPLOYEE_DRIVER ? employeeTypes : [],
        vehicleTypesSelected: originType === EMPLOYEE_VEHICLE ? vehicleTypesSelected : []
      });
    }
  };

  render() {
    const { 
      originType,
      loading, 
      situation, 
      unbound, 
      driverTypes,
      vehicleTypes,
      ...props 
    } = this.props;
    
    const { employeeTypes, vehicleTypesSelected } = this.state;

    return (
      <Grid {...props} container spacing={2} style={{ padding: '10px', marginTop: '20px' }}>
        <Grid item xs={2}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Situação do Cadastro</FormLabel>
            <FormGroup
              aria-label="Situação do Cadastro"
              name="sit"
              disabled={loading}
            >
              <Grid style={{ display: 'flex', direction: 'row', alignItems: 'center' }}> 
                <FormControlLabel
                  value={EXPIRED}
                  label="Vencidos"
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={situation.includes(EXPIRED)}
                      onChange={this.handleSituationChange}
                      value={EXPIRED}
                    />
                  }
                />
                <FiberManualRecordIcon
                  className={dangerSvg}
                />
              </Grid>
              <Grid style={{ display: 'flex', direction: 'row', alignItems: 'center' }}> 
                <FormControlLabel
                  value={LT10}
                  label="Menos de 10 dias"
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={situation.includes(LT10)}
                      onChange={this.handleSituationChange}
                      value={LT10}
                    />
                  }
                />
                <FiberManualRecordIcon
                  className={cautionSvg}
                />
              </Grid>
              <Grid style={{ display: 'flex', direction: 'row', alignItems: 'center' }}> 
                <FormControlLabel
                  value={BT1020}
                  label="Entre 10 e 20 dias"
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={situation.includes(BT1020)}
                      onChange={this.handleSituationChange}
                      value={BT1020}
                    />
                  }
                />
                <FiberManualRecordIcon
                  className={warningSvg}
                />
              </Grid>
              <Grid style={{ display: 'flex', direction: 'row', alignItems: 'center' }}> 
                <FormControlLabel
                  value={BT2030}
                  label="Entre 20 e 30 dias"
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={situation.includes(BT2030)}
                      onChange={this.handleSituationChange}
                      value={BT2030}
                    />
                  }
                />
                <FiberManualRecordIcon
                  className={successSvg}
                />
              </Grid>
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={originType === EMPLOYEE_DRIVER ? 3 : 2}>
          <FormControl component="fieldset">
            <FormLabel component="legend">
              {originType === EMPLOYEE_DRIVER ? 'Tipo de Motorista' : 'Tipo de Veículo'}
            </FormLabel>
            <FormGroup 
              aria-label={originType === EMPLOYEE_DRIVER ? 'Tipo de Motorista' : 'Tipo de Veículo'} 
              name={originType === EMPLOYEE_DRIVER ? 'employeeType' : 'vehicleType'} 
              disabled={loading}
            > 
              {originType === EMPLOYEE_DRIVER && driverTypes.map((type) => (
                <FormControlLabel
                  key={type.id}
                  value={type.id}
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={employeeTypes.includes(type.id)} 
                      onChange={() => this.handleEmployeeTypeChange(type.id)}
                      value={type.id}
                    />
                  }
                  label={type.description}
                />
              ))}
              {originType === EMPLOYEE_VEHICLE && vehicleTypes.map((type) => (
                <FormControlLabel
                  key={type.id}
                  value={type.id}
                  control={
                    <Checkbox 
                      color="primary" 
                      checked={vehicleTypesSelected.includes(type.id)} 
                      onChange={() => this.handleVehicleTypeChange(type.id)}
                      value={type.id}
                    />
                  }
                  label={type.description}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={2}>
          <FormControl component="fieldset">
            <FormLabel component="legend">Visualização</FormLabel>
            <FormGroup
              aria-label="Visualização"
              name="visu"
              disabled={loading}
            >
              <FormControlLabel
                value="desvinculados"
                control={
                  <Checkbox 
                    color="primary" 
                    checked={unbound}
                    onChange={this.handleUnboundChange}
                  />
                }
                label="Exibir Desvinculados"
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={originType === EMPLOYEE_DRIVER ? 3 : 4}>
        </Grid>
        <Grid item xs={2} style={{ alignSelf: 'flex-end' }}>
          <Button
            onClick={this.handleApply}
            color="primary"
            variant="contained"
            style={{ marginBottom: '5px', width: '100%' }}
            disabled={loading}
            size="large"
          >
            BUSCAR
          </Button>
        </Grid>
      </Grid>
    );
  }
}

ListingFilter.propTypes = {
  loading: PropTypes.bool,
  situation: PropTypes.array,
  unbound: PropTypes.bool,
  employeeTypes: PropTypes.array,
  driverTypes: PropTypes.array,
  vehicleTypes: PropTypes.array,
  originType: PropTypes.oneOf([EMPLOYEE_DRIVER, EMPLOYEE_VEHICLE]).isRequired,
  onToggleSituation: PropTypes.func,
  onToggleUnbound: PropTypes.func,
  onApply: PropTypes.func.isRequired
};

ListingFilter.defaultProps = {
  loading: false,
  situation: [],
  unbound: false,
  employeeTypes: [],
  driverTypes: [],
  vehicleTypes: []
};

export default ListingFilter;